import PropTypes from 'prop-types';
import noop from 'lodash/noop';

const {
  func, object, string, bool, array, number, oneOfType,
} = PropTypes;

export const ConfiguratorWrapperPropTypes = {
  onLoadSuccess: func.isRequired,
  config: object.isRequired,
  storeNumber: oneOfType([
    string,
    number,
  ]).isRequired,
  onSaveConfiguration: func.isRequired,
  afterRulesExecuted: func.isRequired,
  isInitialized: bool.isRequired,
  mainImageUrl: func,
  configId: string,
  currentDesignId: string,
  currentItem: object,
  isSaving: bool,
  isLoading: bool,
  omsId: string,
  productId: number,
};

export const defaultConfiguratorWrapperPropTypes = {
  mainImageUrl: noop,
  configId: '',
  currentItem: undefined,
  currentDesignId: undefined,
  isSaving: false,
  isLoading: false,
};

// TODO: move all TConfiguratorChoice references to point to here.
export const TConfiguratorChoice = PropTypes.shape({
  dataType: PropTypes.string,
  dependentOptions: PropTypes.arrayOf(PropTypes.number),
  fillDate: PropTypes.string,
  hasDictionaryTerm: PropTypes.bool,
  id: PropTypes.number,
  internalName: PropTypes.string,
  isActive: PropTypes.bool,
  isAvailable: PropTypes.bool,
  isBackordered: PropTypes.bool,
  isDefault: PropTypes.bool,
  isSelected: PropTypes.bool,
  longLabel: PropTypes.string,
  maxValue: PropTypes.number,
  minValue: PropTypes.number,
  mediaUrl: PropTypes.string,
  media: PropTypes.shape({
    alternateText: PropTypes.string,
    caption: PropTypes.string,
    mediaOwner: PropTypes.string
  }),
  metaDataItems: PropTypes.arrayOf(PropTypes.string),
  optionId: PropTypes.number,
  parentOptionType: PropTypes.string,
  price: PropTypes.number,
  sequence: PropTypes.number,
  shortLabel: PropTypes.string,
  siteProductOptionChoiceShortLabel: PropTypes.string,
  siteProductOptionChoiceLongLabel: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.string,
});
